import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRGetCostsBody{
    "code": string,
}

export interface ESRGetCostsResponse {
    "costs": number,
  }

export const ESRGetCostsResponseSchema : SchemaObject = {
    "costs": "number",
  }
  

export class ESRGetCosts extends Request<ESRGetCostsBody>{
    override method : TRequestMethod = "POST";
    override responseSchema : Schema = ESRGetCostsResponseSchema;

    constructor (
        public sessionToken: string,
        public body: ESRGetCostsBody){
        super();
    }

    override json(): string {
      return JSON.stringify(this.body);
    }

    override route() : string{
        return `${BASEURL}/get_costs?sessionToken=${this.sessionToken}`;
    }
}